import { atom } from "jotai";

export interface UserAuctionsBadgesAtom {
  draftAuctionId?: number;
  activeAuctionId?: number;
}

// State used for
export const userAuctionsBadgesAtom = atom<UserAuctionsBadgesAtom | undefined>(
  undefined
);
